<template>
  <div>
    <div class="card mt-3 pagination-margin">

      <div class="card-body">
        <div class="row">
          <div class="col-sm-6">
            <h5 class="mt-2">
              {{ $t('system.rejected_validations_title') }}
            </h5>
            <div>
              <span v-if="getGuide('rejected_validations_list_page')">
                <GuideButton :guide="getGuide('rejected_validations_list_page')"></GuideButton>
              </span>
            </div>
          </div>
        </div>

        <table class="table table-responsive-md table-list-secondary">
          <thead>
            <tr>
              <th scope="col" class="cursor-pointer">{{ $t('table.name') }}</th>
              <th scope="col" class="cursor-pointer">{{ $t('table.section') }}</th>
              <th scope="col" class="cursor-pointer">{{ $t('table.date') }}</th>
              <th scope="col" class="cursor-pointer">{{ $t('table.validator') }}</th>
              <th scope="col" class="cursor-pointer">{{ $t('validations.create.status_label') }}</th>
              <th width="160"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="validation in validations" qid="validations-list-item">
              <td>
                <span v-if="validation.relation.who_am_i == 'App\\Process\\Models\\Process'">
                  <font-awesome-icon icon="cube" size="lg"/>
                  {{ validation.relation.name }}
                </span>
                <span v-if="validation.relation.who_am_i == 'App\\System\\Models\\System'">
                  <font-awesome-icon icon="desktop" size="lg"/>
                  {{ validation.relation.name }}
                </span>
                <span v-if="validation.relation.who_am_i == 'App\\Activity\\Models\\Activity'">
                  <font-awesome-icon icon="cubes" size="lg"/>
                  {{ validation.relation.name }}
                </span>
                <span v-if="validation.relation.who_am_i == 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty'">
                  <font-awesome-icon icon="file-signature" size="lg"/>
                  {{ validation.relation.name }}
                </span>
                <span v-if="validation.relation.who_am_i == 'App\\RiskScenario\\Models\\RiskScenario'">
                  <font-awesome-icon icon="theater-masks" size="lg"/>
                  {{ validation.relation.name }}
                </span>
                <span v-if="validation.relation.who_am_i == 'App\\GenericControl\\Models\\GenericControl'">
                  <font-awesome-icon icon="shield-alt" size="lg"/>
                  {{ validation.relation.name }}
                </span>
                <span v-if="validation.relation.who_am_i == 'App\\Maintenance\\Policy\\Models\\Policy'">
                  <font-awesome-icon icon="shield-alt" size="lg"/>
                  {{ validation.relation.name }}
                </span>
              </td>
              <td>
                <span class="text-normal">
                  {{ $t('validations.checklist.' + validation.type) }}
                </span>
              </td>
              <td>
                <span class="text-normal">
                  {{ validation.created_at | formatDate }}
                </span>
              </td>
              <td>
                <img v-if="validation.created_by"
                     v-bind:src="getUserAvatar(validation.created_by)"
                     class="rounded-circle mr-2"
                     width="30"
                     height="30"
                     qid="profile-photo"
                >
                <span v-if="validation.created_by" class="text-normal">
                  {{ validation.created_by.name }}
                </span>
              </td>
              <td>
                <span v-if="validation.validation === 1" qid="validations-status-approved" class="text-normal">
                  <font-awesome-icon icon="check-circle" class="icon-success"/>
                  {{ $t('system.approved') }}
                </span>
                <span v-if="validation.validation === 0" qid="validations-status-rejected" class="text-normal">
                  <font-awesome-icon icon="times-circle" class="icon-danger"/>
                  {{ $t('system.rejected') }}
                </span>
              </td>
              <td align="right">
                <button class="btn btn-success float-right pl-1 pr-1"
                        @click="goToValidation(validation)"
                >
                  {{ $t('system.my_validation_link') }}
                </button>
              </td>
            </tr>
            <tr v-if="!loading && !validations.length" qid="no-results-row" class="text-center">
              <td colspan="10">
                <h5 class="mt-3">
                  {{ $t('system.no_results') }}
                </h5>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="card-body">
        <div class="pagination row">
          <div class="col-md-6">
            <div class="row">
              <div class="float-left">
                <span class="text-muted pagination-counter">
                  {{ $t('pagination.entries_per_page') }}:
                </span>
              </div>
              <div class="float-left">
                <multiselect
                    v-model="perPage"
                    :options="perPageOptions"
                    track-by="value"
                    label="value"
                    :select-label="$t('system.dropdown_select_label')"
                    :selected-label="$t('system.dropdown_selected_label')"
                    :deselect-label="$t('system.dropdown_deselect_label')"
                    qid="create-org-form-organization-level"
                    @select="perPageChanged"
                    :placeholder="selectedPerPage"
                    @remove="perPageRemoved"
                ></multiselect>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <b-pagination
                class="float-right"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="selectedPerPage"
                aria-controls="my-table"
                @change="pageChanged"
                limit="1"
            >
              <span class="text-muted" slot="first-text"><font-awesome-icon icon="angle-double-left"/></span>
              <span class="text-muted" slot="prev-text"><font-awesome-icon icon="angle-left"/></span>
              <span class="text-muted" slot="next-text"><font-awesome-icon icon="angle-right"/></span>
              <span class="text-muted" slot="last-text"><font-awesome-icon icon="angle-double-right"/></span>
              <div slot="ellipsis-text">
                <b-spinner small type="grow"></b-spinner>
                <b-spinner small type="grow"></b-spinner>
                <b-spinner small type="grow"></b-spinner>
              </div>
              <span class="text-muted" slot="page" slot-scope="{ page, active }">
                <span v-if="active">{{getPerPage}}</span>
              </span>
            </b-pagination>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import {config} from '@/config.js'
  import GuideButton from '@/components/guide/GuideButton.vue';

  export default {
    name: 'RejectedValidations',
    props: {

    },
    data: function() {
      return {

        perPageOptions: [
          { name: '10', value: '10' },
          { name: '20', value: '20' },
          { name: '50', value: '50' },
          { name: '100', value: '100' }
        ],
        perPage: '',
        selectedPerPage: "10",
        currentPage: 1,
        totalRows: 0,
        validations: [],

        error: '',
        selectedFiles: [],
        loading: true,
        buttonDisabled: false,
        myGuides: []
      }
    },
    components: {
      GuideButton
    },
    computed: {
      rows() {
        // Use computed value for rows because of dynamic update
        return this.totalRows
      },
      getClient() {
        return this.$store.state.client
      },
      getFiles() {
        return this.selectedFiles
      },
      getStorePerPage() {
        return this.$store.state.perPage
      },
      getPerPage() {
        let page = this.currentPage;
        let selectedFrom = (page-1) * Number(this.selectedPerPage) + 1;
        let selectedTo = (page-1) * Number(this.selectedPerPage) + Number(this.selectedPerPage);
        let selectedOf = this.totalRows;

        if(selectedTo > selectedOf){
          selectedTo = selectedOf
        }

        return selectedFrom + " - " + selectedTo + " of " + selectedOf
      }
    },
    watch: {
      getClient: function (newValue, oldValue) {
        this.loadValidations()
      },
    },
    methods: {
      getGuide(code) {
        let existingGuide = _.find(this.myGuides, function(object) {
          return object.scope == code && object.enabled
        });
        return existingGuide
      },
      loadGuides(code) {
        let self = this;
        let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

        piincHttp.get('guides', { params:
          {
            per_page: 1,
            language: 'en',
            scope: code,
            client: this.getClient.slug
          }
        }).then(function(response) {
          if (response.data.items.length) {
            self.myGuides.push(response.data.items[0])
          }
        }, function() {});
      },
      goToValidation(validation) {
        if (validation.relation.who_am_i == 'App\\Process\\Models\\Process') {
          if (validation.type == 'legal_basis' ||
              validation.type == 'information_obligation' ||
              validation.type == 'risk_profile' ||
              validation.type == 'confidentiality' ||
              validation.type == 'integrity' ||
              validation.type == 'availability'
          ) {
            this.tabIndex = 1;
          }
          if (validation.type == 'risk_scenario') {
            this.tabIndex = 2;
          }
          this.$router.push({name: 'processes.view', params: {slug: validation.relation.slug, tabIndex: this.tabIndex, validation: validation.type}})
        }
        if (validation.relation.who_am_i == 'App\\System\\Models\\System') {
          if (validation.type == 'risk_scenario') {
            this.tabIndex = 2;
          }
          this.$router.push({name: 'systems.view', params: {slug: validation.relation.slug, tabIndex: this.tabIndex, validation: validation.type}})
        }
        if (validation.relation.who_am_i == 'App\\Activity\\Models\\Activity') {
          if (validation.type == 'mapping_description') {
            this.tabIndex = 1;
          }
          if (validation.type == 'retention_rule' ||
              validation.type == 'integrity_check' ||
              validation.type == 'processing_type'
          ) {
            this.tabIndex = 2;
          }
          if (validation.type == 'risk_scenario') {
            this.tabIndex = 3;
          }
          this.$router.push({name: 'activities.view', params: {slug: validation.relation.slug, tabIndex: this.tabIndex, validation: validation.type}})
        }
        if (validation.relation.who_am_i == 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty') {
          if (validation.type == 'risk_scenario') {
            this.tabIndex = 3;
          }
          if (validation.type == 'third_party') {
            this.tabIndex = 8;
          }
          this.$router.push({name: 'contracts.view', params: {slug: validation.relation.slug, tabIndex: this.tabIndex, validation: validation.type}})
        }
        if (validation.relation.who_am_i == 'App\\RiskScenario\\Models\\RiskScenario') {
          if (validation.type == 'risk_scenario') {
            this.tabIndex = 4;
          }
          this.$router.push({name: 'risk_scenarios.view', params: {slug: validation.relation.slug, tabIndex: this.tabIndex, validation: validation.type}})
        }
        if (validation.relation.who_am_i == 'App\\GenericControl\\Models\\GenericControl') {
          if (validation.type == 'generic_control') {
            this.tabIndex = 4;
          }
          this.$router.push({name: 'generic_controls.view', params: {slug: validation.relation.slug, tabIndex: this.tabIndex, validation: validation.type}})
        }
        if (validation.relation.who_am_i == 'App\\Maintenance\\Policy\\Models\\Policy') {
          if (validation.type == 'policy') {
            this.tabIndex = 2;
          }
          this.$router.push({name: 'policies.view', params: {slug: validation.relation.slug, tabIndex: this.tabIndex, validation: validation.type}})
        }
      },
      loadValidations(page, perPage) {

        if (this.getStorePerPage) {
          this.selectedPerPage = this.getStorePerPage;
        }

        // If page is not defined, set page to default 1
        let pageNumber = page ? page : 1;
        let perPageNumber = perPage ? perPage : this.selectedPerPage;
        let self = this;

        piincHttp.get('validations/rejected', { params:
          {
            page: pageNumber,
            per_page: perPageNumber,
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.loading = false;
          self.validations = response.data.items;
          // Set number of total items
          self.totalRows = response.data.total_count;
          // Emit event to parent component to update newest validation
        }, function() {});

      },
      pageChanged(page) {
        // Load Third parties when page changed listener is triggered
        this.loadValidations(page)
      },
      perPageChanged(perPage) {
        let self = this;

        self.selectedPerPage = perPage.value
        this.$store.commit('storePerPage', this.selectedPerPage);
        this.loadValidations(1, perPage.value)
      },
      perPageRemoved() {
        let self = this;
        self.selectedPerPage = self.perPageOptions[0].value
        this.loadValidations(1, self.selectedPerPage)
      },
      pageChanged(page) {
        // Load validation when page changed listener is triggered
        this.loadValidations(page)
      },
      getUserAvatar(user){
        if (user && user.avatar) {
          return user.avatar;
        } else {
          return require('@/assets/avatar.png');
        }
      },
    },
    created() {
      if (this.getClient && this.getClient.slug) {
        this.loadValidations()
      }

      this.loadGuides('rejected_validations_list_page');

      if (this.type === 'none') {
        this.validationForm.checklist = null;
      }

    }
  }
</script>
